import React from 'react';
import { AboutFounderImage } from './AboutFounderImage';
import { AboutFounderText } from './AboutFounderText';

export const AboutFounderContent: React.FC = () => {
	return (
		<div className='self-end mt-14 max-w-full max-md:mt-10 md:px-20'>
			<div className='flex gap-5 max-md:flex-col'>
				<div className='w-[35%] max-md:ml-0 max-md:w-full'>
					<AboutFounderImage />
				</div>
				<div className='ml-auto w-[50%] max-md:ml-0 max-md:w-full px-5'>
					<AboutFounderText />
				</div>
			</div>
		</div>
	);
};
